import React from "react";
import ContentLoader from "react-content-loader";
import styled from "styled-components";
import { useTheme as useStyledTheme } from "styled-components";
import { FiX } from "react-icons/fi";

const NotificationModalSkeleton = () => {
  const theme = useStyledTheme();
  const backgroundColor = theme?.card || "#1a1a1a";
  const foregroundColor = theme?.card2 || "#2a2a2a";

  return (
    <Overlay>
      <ModalContainer onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <ModalHeader>
          <div className="header-left">
            <div className="title-row">
              <ContentLoader
                speed={2}
                width={400}
                height={24}
                backgroundColor={backgroundColor}
                foregroundColor={foregroundColor}
              >
                <rect x="0" y="0" rx="4" ry="4" width="400" height="24" />
              </ContentLoader>
            </div>
            <div className="remetente-info">
              <ContentLoader
                speed={2}
                width={250}
                height={16}
                backgroundColor={backgroundColor}
                foregroundColor={foregroundColor}
              >
                <rect x="0" y="0" rx="3" ry="3" width="250" height="16" />
              </ContentLoader>
            </div>
            <div className="meta-info">
              <ContentLoader
                speed={2}
                width={300}
                height={13}
                backgroundColor={backgroundColor}
                foregroundColor={foregroundColor}
              >
                <rect x="0" y="0" rx="3" ry="3" width="100" height="13" />
                <rect x="120" y="0" rx="3" ry="3" width="180" height="13" />
              </ContentLoader>
            </div>
          </div>
          <div className="header-actions">
            <button className="close-btn" title="Fechar">
              <FiX />
            </button>
          </div>
        </ModalHeader>

        {/* Body */}
        <ModalBody>
          {/* Informações Section */}
          <Section>
            <div className="section-header-simple">
              <ContentLoader
                speed={2}
                width={120}
                height={14}
                backgroundColor={backgroundColor}
                foregroundColor={foregroundColor}
              >
                <rect x="0" y="0" rx="3" ry="3" width="120" height="14" />
              </ContentLoader>
            </div>
            <InfoGrid>
              {[1, 2, 3].map((i) => (
                <InfoItem key={i}>
                  <div className="info-icon">
                    <ContentLoader
                      speed={2}
                      width={18}
                      height={18}
                      backgroundColor={backgroundColor}
                      foregroundColor={foregroundColor}
                    >
                      <rect x="0" y="0" rx="3" ry="3" width="18" height="18" />
                    </ContentLoader>
                  </div>
                  <div className="info-content">
                    <ContentLoader
                      speed={2}
                      width={100}
                      height={10}
                      backgroundColor={backgroundColor}
                      foregroundColor={foregroundColor}
                    >
                      <rect x="0" y="0" rx="2" ry="2" width="100" height="10" />
                    </ContentLoader>
                    <ContentLoader
                      speed={2}
                      width={150}
                      height={16}
                      backgroundColor={backgroundColor}
                      foregroundColor={foregroundColor}
                      style={{ marginTop: "4px" }}
                    >
                      <rect x="0" y="0" rx="3" ry="3" width="150" height="16" />
                    </ContentLoader>
                  </div>
                </InfoItem>
              ))}
            </InfoGrid>
          </Section>

          {/* Assunto Section */}
          <Section>
            <SectionTitle>
              <ContentLoader
                speed={2}
                width={80}
                height={12}
                backgroundColor={backgroundColor}
                foregroundColor={foregroundColor}
              >
                <rect x="0" y="0" rx="3" ry="3" width="80" height="12" />
              </ContentLoader>
            </SectionTitle>
            <SectionContent>
              <ContentLoader
                speed={2}
                width="100%"
                height={80}
                backgroundColor={backgroundColor}
                foregroundColor={foregroundColor}
              >
                <rect x="0" y="0" rx="3" ry="3" width="100%" height="16" />
                <rect x="0" y="24" rx="3" ry="3" width="95%" height="16" />
                <rect x="0" y="48" rx="3" ry="3" width="90%" height="16" />
                <rect x="0" y="72" rx="3" ry="3" width="70%" height="16" />
              </ContentLoader>
            </SectionContent>
          </Section>

          {/* Parecer Section */}
          <Section>
            <SectionTitle>
              <ContentLoader
                speed={2}
                width={80}
                height={12}
                backgroundColor={backgroundColor}
                foregroundColor={foregroundColor}
              >
                <rect x="0" y="0" rx="3" ry="3" width="80" height="12" />
              </ContentLoader>
            </SectionTitle>
            <SectionContent>
              <ContentLoader
                speed={2}
                width="100%"
                height={60}
                backgroundColor={backgroundColor}
                foregroundColor={foregroundColor}
              >
                <rect x="0" y="0" rx="3" ry="3" width="100%" height="16" />
                <rect x="0" y="24" rx="3" ry="3" width="90%" height="16" />
                <rect x="0" y="48" rx="3" ry="3" width="85%" height="16" />
              </ContentLoader>
            </SectionContent>
          </Section>

          {/* Importância Section */}
          <Section>
            <div className="section-header-simple">
              <ContentLoader
                speed={2}
                width={100}
                height={14}
                backgroundColor={backgroundColor}
                foregroundColor={foregroundColor}
              >
                <rect x="0" y="0" rx="3" ry="3" width="100" height="14" />
              </ContentLoader>
            </div>
            <ImportanceContent>
              <ImportanceTag>
                <ContentLoader
                  speed={2}
                  width="100%"
                  height={16}
                  backgroundColor={backgroundColor}
                  foregroundColor={foregroundColor}
                >
                  <rect x="0" y="0" rx="3" ry="3" width="80%" height="16" />
                </ContentLoader>
              </ImportanceTag>
              <ImportanceTag>
                <ContentLoader
                  speed={2}
                  width="100%"
                  height={16}
                  backgroundColor={backgroundColor}
                  foregroundColor={foregroundColor}
                >
                  <rect x="0" y="0" rx="3" ry="3" width="70%" height="16" />
                </ContentLoader>
              </ImportanceTag>
            </ImportanceContent>
          </Section>
        </ModalBody>
      </ModalContainer>
    </Overlay>
  );
};

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  padding: 2em;
  backdrop-filter: blur(4px);
`;

const ModalContainer = styled.div`
  background: ${({ theme }) => theme.card};
  border-radius: 16px;
  width: 100%;
  max-width: 900px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  border: 1px solid ${({ theme }) => theme.border};
  animation: modalFadeIn 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  @keyframes modalFadeIn {
    from {
      opacity: 0;
      transform: scale(0.95) translateY(10px);
    }
    to {
      opacity: 1;
      transform: scale(1) translateY(0);
    }
  }
`;

const ModalHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 1.5em 2em;
  border-bottom: 1px solid ${({ theme }) => theme.border};
  gap: 1em;

  .header-left {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 0.8em;
  }

  .header-actions {
    display: flex;
    align-items: center;
    gap: 8px;

    button {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 40px;
      height: 40px;
      background: ${({ theme }) => theme.buttonBg};
      border: 1px solid ${({ theme }) => theme.border};
      border-radius: 12px;
      color: ${({ theme }) => theme.text};
      cursor: pointer;
      transition: all 0.2s ease;
      font-size: 1.2em;

      &:hover {
        background: rgba(239, 68, 68, 0.1);
        border-color: #ef4444;
        color: #ef4444;
      }
    }
  }
`;

const ModalBody = styled.div`
  padding: 2em;
  overflow-y: auto;
  flex: 1;

  &::-webkit-scrollbar {
    width: 8px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.border};
    border-radius: 6px;

    &:hover {
      background: ${({ theme }) => theme.text}40;
    }
  }
`;

const Section = styled.div`
  margin-bottom: 2em;

  &:last-child {
    margin-bottom: 0;
  }

  .section-header-simple {
    margin-bottom: 1em;
  }
`;

const SectionTitle = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: ${({ theme }) => theme.card};
  border: 1px solid ${({ theme }) => theme.border};
  border-bottom: none;
  border-radius: 6px 6px 0 0;
  margin-bottom: 0;
  position: relative;
  top: 1px;
`;

const SectionContent = styled.div`
  background: ${({ theme }) => theme.buttonBg};
  border: 1px solid ${({ theme }) => theme.border};
  border-radius: 0 10px 10px 10px;
  padding: 1.2em;
`;

const InfoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.8em;

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;

const InfoItem = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px;
  min-height: 60px;
  background: ${({ theme }) => theme.card};
  border: 1px solid ${({ theme }) => theme.border};
  border-radius: 12px;
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    width: 3px;
    background: linear-gradient(90deg, #3b82f6, #60a5fa);
  }

  .info-icon {
    width: 32px;
    height: 32px;
    min-width: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(59, 130, 246, 0.1);
    border-radius: 12px;
  }

  .info-content {
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
  }
`;

const ImportanceContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.8em;
`;

const ImportanceTag = styled.div`
  padding: 0.8em 1em;
  background: ${({ theme }) =>
    theme.body === "#fafbfc"
      ? "rgba(239, 68, 68, 0.04)"
      : "rgba(239, 68, 68, 0.08)"};
  border-left: 3px solid rgba(239, 68, 68, 0.3);
  border-radius: 6px;
`;

export default NotificationModalSkeleton;
